<script setup>
import { ref, watch } from 'vue';
import asignaturas from '@/api/cifra/asignaturas';
import useEstructuraChangeEvent from '@/composables/useEstructuraChangeEvent';
import SelectCifra from './SelectCifra.vue';

const props = defineProps({
  selectorEstructuraEl: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  filtrosAdicionales: { type: Object, default: () => ({}) },
  soloInferiores: { type: Boolean, default: true },
  seleccionInicial: { type: Array, default: () => [] },

  campoEtiqueta: { type: String, default: 'nombre' },
  marcador: { type: String, default: undefined },
  nombreInput: { type: String, default: undefined },
  mostrarLimpiar: { type: Boolean, default: false },
  campoId: { type: String, default: 'id' },
  valoresGrupo: { type: String, default: undefined },
  etiquetaGrupo: { type: String, default: undefined },
});

const emit = defineEmits(['cargando']);

const seleccion = defineModel({ type: [String, Number, Object, Array], default: null });
const opciones = ref([]);
const loading = ref(false);

function convertirPathAParametros(path) {
  const params = {};
  (path || []).forEach((nodo) => {
    params[`${nodo.type}_id`] = nodo.id;
  });
  return params;
}

async function cargar(estructura) {
  const params = {
    inferiores: props.soloInferiores,
    superiores: false,
    ...props.filtrosAdicionales,
    ...(Array.isArray(estructura) ? convertirPathAParametros(estructura) : (estructura || {})),
  };

  if (!params.grupo_id && !params.curso_id) {
    opciones.value = [];
    return;
  }

  loading.value = true;
  emit('cargando', true);
  try {
    const result = await asignaturas.list(params);
    opciones.value = result.data;
  } catch {
    opciones.value = [];
  } finally {
    loading.value = false;
    emit('cargando', false);
  }
}

function limpiar() {
  seleccion.value = props.multiple ? [] : null;
  opciones.value = [];
}

if (props.selectorEstructuraEl) {
  const { pathComoParametros } = useEstructuraChangeEvent(props.selectorEstructuraEl);

  watch(pathComoParametros, async (params) => {
    seleccion.value = props.multiple ? [] : null;
    await cargar(params);
  });
}

defineExpose({ cargar, limpiar });
</script>

<template>
  <SelectCifra
    v-model="seleccion"
    :opciones="opciones"
    :cargando="loading"
    :multiple="multiple"
    :seleccion-inicial="seleccionInicial"
    :campo-etiqueta="campoEtiqueta"
    :marcador="marcador"
    :nombre-input="nombreInput"
    :mostrar-limpiar="mostrarLimpiar"
    :campo-id="campoId"
    :valores-grupo="valoresGrupo"
    :etiqueta-grupo="etiquetaGrupo"
  >
    <template v-for="(_, name) in $slots" #[name]="data">
      <slot :name="name" v-bind="data" />
    </template>
  </SelectCifra>
</template>

<style lang="scss" scoped>
</style>
